var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.paymentMethod === "pix"
    ? _c("section", { staticClass: "el-section" }, [
        _c("div", { staticClass: "el-chunk" }, [
          _vm._m(0),
          _c("div", { staticClass: "el-chunk" }, [
            _c("h2", { staticClass: "emd-text _size_page" }, [
              _vm._v(" " + _vm._s(_vm.$t("pix.orderCreated.success")) + " "),
            ]),
          ]),
        ]),
        _c("p", { staticClass: "el-chunk" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("pix.orderCreated.label", {
                  expiresAt: _vm.expiresAt,
                  totalAmount: _vm.totalAmount,
                })
              ) +
              " "
          ),
        ]),
        _c("img", { attrs: { alt: "QR Code", src: _vm.qrCodeImage } }),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-chunk" }, [
      _c("span", { staticClass: "emd-text _color_success" }, [
        _c("i", {
          staticClass: "uil uil-check-circle",
          staticStyle: { "font-size": "3rem" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }